import React, { useEffect, useState } from "react";

import { CardContent, CardHeader, CardTitle } from "./ui/card";
import { ArrowLeft } from "lucide-react";
import { Button } from "./ui/button";
import CurrencyFormatter from "../utils/currencyFormatter";
import info from "../assets/icons/info_icon.svg";
import TwoFA from "./MainTwoFA";
import EnableTwoFA from "./EnableTwoFA";
import withOverlay from "../hoc/withOverlay";
import { useAuth } from "../context/AuthContext";
const TwoFAOverlay = withOverlay(TwoFA);
export default function InvestWithdrawDepositOverview({
  type,
  depositQuote,
  asset,
  productName,
  onConfirm,
  onBack,
  setUp,
  withdrawQuote,
}) {
  const [open, setOpen] = useState(false);
  const [isConfirmed, setIsComfirmed] = useState(false);
  const [isTwoFAOpen, setIsTwoFAOpen] = useState(false);
  const [isEnabled, setIsEnabled] = useState(false);

  const { settings } = useAuth();

  const formatter = new CurrencyFormatter();

  useEffect(() => {
    setIsEnabled(settings?.security?.twoFactorAuth?.enabled);
  }, [settings]);

  const handleCloseOverlay = () => {
    setIsTwoFAOpen(false);
    setIsComfirmed(false);
  };

  const handleClose = () => {
    setIsComfirmed(false);
  };

  const handleQuote = async () => {
    try {
      setIsComfirmed(true);
      if (!isEnabled) {
        setOpen(true);
      }
      if (isEnabled) {
        onConfirm?.();
      }

      // setPageNo(2);
    } catch (error) {
    } finally {
    }
  };
  const handleSetUp = () => {
    if (setUp) {
      setUp();
    }
  };

  return (
    <>
      {
        <>
          <CardHeader className="mb-4  px-20">
            <CardTitle>
              {type === "withdraw" ? (
                <h3 className="text-[20px] text-text-secondary font-semibold">
                  Review your withdrawal
                </h3>
              ) : (
                <h3 className="text-[20px] text-text-secondary font-semibold">
                  Review your deposit
                </h3>
              )}
            </CardTitle>
          </CardHeader>
          <CardContent className="px-20 pb-8 outline outline-gray-50 rounded-lg outline-1">
            <div className="mb-2">
              <div className="">
                <div className="flex items-center justify-between px-3 py-3 border rounded-t-lg">
                  <p className="text-[14px] text-text-primary font-normal">
                    {type === "withdraw" ? "You withdraw" : "You deposit"}
                  </p>
                  {type === "withdraw" ? (
                    <p className="text-[16px] text-text-primary font-semibold">
                      {formatter.format(
                        withdrawQuote?.amount,
                        asset?.toUpperCase()
                      )}
                    </p>
                  ) : (
                    <p className="text-[16px] text-text-primary font-semibold">
                      {formatter.format(
                        depositQuote?.amount,
                        asset?.toUpperCase()
                      )}
                    </p>
                  )}
                </div>
                <div className="flex items-center justify-between px-3 py-3 border-r border-l border-b">
                  <p className="text-[14px] text-text-primary font-normal">
                    {type === "withdraw" ? "Withdraw from" : "Deposit from"}
                  </p>
                  <p className="text-[16px] text-text-primary font-semibold">
                    {type === "withdraw" ? productName : "Digital Wallet"}
                  </p>
                </div>
                <div className="flex items-center justify-between px-3 py-3 border-r border-l border-b">
                  <p className="text-[14px] text-text-primary font-normal">
                    {type === "withdraw" ? "Withdraw to" : "Deposit to"}
                  </p>
                  <p className="text-[16px] text-text-primary font-semibold">
                    {type === "withdraw" ? "Digital Wallet" : productName}
                  </p>
                </div>
                <div className="flex items-center justify-between px-3 py-3 border-r border-l">
                  <div className="flex">
                    {type === "withdraw" ? (
                      <p className="text-[14px] text-text-primary font-normal mr-2">
                        Withdrawal Fee
                      </p>
                    ) : (
                      <p className="text-[14px] text-text-primary font-normal mr-2">
                        Deposit Fee
                      </p>
                    )}
                    <img src={info} alt="" />
                  </div>
                  {type === "withdraw" ? (
                    <p className="text-[16px] text-text-primary font-semibold">
                      {/* {withdrawQuote?.withdrawalFee
                        ? withdrawQuote?.formattedWithdrawalFee
                        : "R 0.00"} */}
                      R 0.00
                    </p>
                  ) : (
                    <p className="text-[16px] text-text-primary font-semibold">
                      {/* {depositQuote?.depositFee
                        ? depositQuote?.formattedDepositFee
                        : "R 0.00"} */}
                      R 0.00
                    </p>
                  )}
                </div>
                <div className="flex items-center justify-between px-3 py-3 border rounded-b-lg">
                  <p className="text-[14px] text-text-primary font-semibold">
                    Total {type === "withdraw" ? "Withdraw" : "Deposit"} Amount
                  </p>
                  {type === "withdraw" ? (
                    <p className="text-[16px] text-text-primary font-semibold">
                      {withdrawQuote?.totalAmount
                        ? withdrawQuote?.formattedTotalAmount
                        : formatter.format(
                            withdrawQuote?.amount,
                            asset?.toUpperCase()
                          )}
                    </p>
                  ) : (
                    <p className="text-[16px] text-text-primary font-semibold">
                      {depositQuote?.totalAmount
                        ? depositQuote?.formattedTotalAmount
                        : formatter.format(
                            depositQuote?.amount,
                            asset?.toUpperCase()
                          )}
                    </p>
                  )}
                </div>
              </div>
            </div>
            <div className="flex justify-center items-center  mt-5 py-6">
              <div
                className="min-h-[50px] min-w-[50px] border rounded-full flex justify-center items-center mr-2"
                onClick={() => onBack?.()}
              >
                <ArrowLeft
                  size={22}
                  strokeWidth={1}
                  className="text-gray-700"
                />
              </div>
              <Button
                onClick={handleQuote}
                disabled={isConfirmed}
                className="py-4 px-[150px] h-15 bg-gradient-to-tr from-purple-500 to-rose-500 text-white rounded-full font-bold"
              >
                Continue
              </Button>
              <EnableTwoFA
                open={open}
                setOpen={setOpen}
                setIsTwoFAOpen={setIsTwoFAOpen}
                onClose={handleClose}
              />
            </div>
            <TwoFAOverlay
              isOpen={isTwoFAOpen}
              closeOverlay={handleCloseOverlay}
              isSetUp={handleSetUp}
            />
          </CardContent>
        </>
      }
    </>
  );
}
